// Bump this string on every deploy-worthy change so the live site can be
// visually checked against what was actually published.
export const BUILD_VERSION = "2026-09-01.1";
